import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { endpoints } from 'global/endpoints';
import { routePaths } from 'global/routePaths';
import http from 'utils/http';
import toaster from 'utils/toaster';

export const resetPassword = (postData: any) => {
  return http().post(endpoints.resetPassword, postData);
};

export function useResetPassword() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: resetPassword,
    onError: (errorData: any) => {
      let errorMessage: any = '';
      if (errorData?.data) {
        toaster.error({ description: errorData?.data?.message });
      } else {
        errorMessage = errorData?.message || errorData?.error?.message || 'Unable to fetch data';
        toaster.error({ description: errorMessage });
      }
    },
    onSuccess: data => {
      toaster.success({ description: data?.message || data?.data?.message });
      navigate(routePaths.auth.resetPasswordSuccess);
    },
  });
}
